webpackJsonp([7],{

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _icon = __webpack_require__(73);

var _icon2 = _interopRequireDefault(_icon);

__webpack_require__(74);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Loading = function Loading(_) {
    return _react2.default.createElement(
        'div',
        { className: 'loadingWrapper' },
        _react2.default.createElement(_icon2.default, { type: 'loading' })
    );
};

exports.default = Loading;

/***/ }),

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _redux = __webpack_require__(72);

var _reduxLogger = __webpack_require__(244);

var _reduxLogger2 = _interopRequireDefault(_reduxLogger);

var _reduxSaga = __webpack_require__(245);

var _reduxSaga2 = _interopRequireDefault(_reduxSaga);

var _reducers = __webpack_require__(135);

var _reducers2 = _interopRequireDefault(_reducers);

var _sagas = __webpack_require__(137);

var _sagas2 = _interopRequireDefault(_sagas);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sagaMiddleware = (0, _reduxSaga2.default)();

var store = (0, _redux.createStore)(_reducers2.default, (0, _redux.applyMiddleware)(sagaMiddleware));
if (false) {
	store = (0, _redux.createStore)(_reducers2.default, (0, _redux.applyMiddleware)(_reduxLogger2.default, sagaMiddleware));
}

_sagas2.default.map(function (val) {
	sagaMiddleware.run(val);
});

exports.default = store;

/***/ }),

/***/ 115:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = ['/login'];

/***/ }),

/***/ 128:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(33);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(34);

var _reactRedux = __webpack_require__(118);

var _promisePolyfill = __webpack_require__(116);

var _promisePolyfill2 = _interopRequireDefault(_promisePolyfill);

var _reactLoadable = __webpack_require__(117);

var _reactLoadable2 = _interopRequireDefault(_reactLoadable);

var _index = __webpack_require__(76);

var _index2 = _interopRequireDefault(_index);

var _tools = __webpack_require__(35);

var _store = __webpack_require__(114);

var _store2 = _interopRequireDefault(_store);

__webpack_require__(115);

var _loading = __webpack_require__(113);

var _loading2 = _interopRequireDefault(_loading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (!window.Promise) {
	window.Promise = _promisePolyfill2.default;
}

var Load = function Load(loader) {
	return (0, _reactLoadable2.default)({
		loader: loader,
		loading: _loading2.default
	});
};
// 判断是否是ios 还是 android
var u = navigator.userAgent;
window.isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
window.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
window.platform = u.indexOf('Feishu') >= 0 || u.indexOf('Lark') >= 0 ? 'feishu' : 'wxwork'; //钉钉 or 企业微信
//飞书appId
// window.feishu_appid = 'cli_a74bf532c16b901c';//测试
window.feishu_appid = 'cli_a74028a26c4a500c'; //生产
// window.feishu_appid = 'cli_a7a33fc3d3e2900b';//UAT
// 用户认证，入口带有微信转发的参数code，可以根据code获得用户的openId
var params = (0, _tools.handleLocation)();
console.log('params -> ', params);
if (params.code) {
	_index2.default.fetchAuth({ code: params.code });
} else if (params.psncode) {
	_index2.default.fetchAuth(params);
}

var Page = Load(function () {
	return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 127));
});
var Home = Load(function () {
	return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 130));
});
var Processform = Load(function () {
	return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 132));
});
var Editform = Load(function () {
	return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 131));
});
var ErrorPage = Load(function () {
	return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 129));
});
var LoginPage = Load(function () {
	return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 133));
});

var routeConfig = _react2.default.createElement(
	_reactRouter.Route,
	{ path: '/', component: Page },
	_react2.default.createElement(_reactRouter.IndexRedirect, { to: '/home' }),
	_react2.default.createElement(_reactRouter.Route, { path: 'home', component: Home }),
	_react2.default.createElement(_reactRouter.Route, { path: 'processform', component: Processform }),
	_react2.default.createElement(_reactRouter.Route, { path: 'editform', component: Editform }),
	_react2.default.createElement(_reactRouter.Route, { path: 'error', component: ErrorPage }),
	_react2.default.createElement(_reactRouter.Route, { path: 'login', component: LoginPage })
);

_reactDom2.default.render(_react2.default.createElement(
	_reactRedux.Provider,
	{ store: _store2.default },
	_react2.default.createElement(
		_reactRouter.Router,
		{ history: _reactRouter.hashHistory },
		routeConfig
	)
), document.getElementById('root'));

/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.GlobalReducer = undefined;

var _tools = __webpack_require__(35);

var _action = __webpack_require__(79);

var globalDataStructure = {
	loading: false,
	panes: [],
	activeKey: '',
	cartlist: {}
};

var GlobalReducer = exports.GlobalReducer = function GlobalReducer() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : globalDataStructure;
	var action = arguments[1];

	switch (action.type) {

		case _action.START_LOADING:
			return (0, _tools.Assign)(state, { loading: true });
		case _action.CLOSE_LOADING:
			return (0, _tools.Assign)(state, { loading: false });

		case _action.SET_ACTIVE:
			return (0, _tools.Assign)(state, { activeKey: action.key });

		case _action.UPDATE_CART:
			return (0, _tools.Assign)(state, { cartlist: action.data });

		case _action.RESET:
			return globalDataStructure;

		default:
			return state;
	}
};

/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _redux = __webpack_require__(72);

var _globalReducers = __webpack_require__(134);

exports.default = (0, _redux.combineReducers)({
	global: _globalReducers.GlobalReducer
});

/***/ }),

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(75);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.default = _callee;

var _effects = __webpack_require__(108);

var _reactRouter = __webpack_require__(34);

var _action = __webpack_require__(79);

var ACTION = _interopRequireWildcard(_action);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(_callee);

function _callee() {
  return _regenerator2.default.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _fetchsaga = __webpack_require__(136);

var _fetchsaga2 = _interopRequireDefault(_fetchsaga);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = [_fetchsaga2.default];

/***/ }),

/***/ 180:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 181:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 182:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 183:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 35:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
var Assign = exports.Assign = function Assign(prevState, nextState) {
	return Object.assign({}, prevState, nextState);
};

var dateformat = exports.dateformat = function dateformat(date) {
	var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yyyy-MM-dd';
	//author: meizz
	var o = {
		"M+": date.getMonth() + 1, //月份
		"d+": date.getDate(), //日
		"H+": date.getHours(), //小时
		"m+": date.getMinutes(), //分
		"s+": date.getSeconds(), //秒
		"q+": Math.floor((date.getMonth() + 3) / 3), //季度
		"f+": date.getMilliseconds() //毫秒
	};
	if (/(y+)/.test(format)) format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
	for (var k in o) {
		if (new RegExp("(" + k + ")").test(format)) format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
	}return format;
};

var handleLocation = exports.handleLocation = function handleLocation(_) {
	var s = location.search.substring(1, location.search.length);
	var search = {};
	var a = [s];
	if (s.length > 1 && s.indexOf('&') > 0 && s) {
		a = s.split('&');
	}
	a.forEach(function (val) {
		var b = val.split('=');
		search[b[0]] = b[1];
	});
	return search;
};

// 认证微信JS-SDk
var wxJsSDK = exports.wxJsSDK = function wxJsSDK(obj) {
	wx.config({
		beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
		debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
		appId: obj.appid, // 必填，企业微信的corpID
		timestamp: obj.timestamp, // 必填，生成签名的时间戳
		nonceStr: obj.noncestr, // 必填，生成签名的随机串
		signature: obj.signature, // 必填，签名，见 附录-JS-SDK使用权限签名算法
		jsApiList: ['previewFile'] // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
	});
	wx.ready(function () {
		// config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
		console.log('JS-SDK 认证成功');
	});
	wx.error(function (res) {
		// config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
		console.log('JS-SDK 认证失败');
	});
};

//下载文件
var dealBlob = exports.dealBlob = function dealBlob(data, filename) {
	var userAgent = window.navigator.userAgent;
	var isMobile = window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i); // 是否手机端
	if (isMobile && userAgent.indexOf('wxwork') >= 0) {
		wx.invoke("previewFile", {
			url: data.url, // 需要预览文件的地址(必填，可以使用相对路径)
			name: filename, // 需要预览文件的文件名，必须有带文件格式的后缀，例如.doc(不填的话取url的最后部分，最后部分是个包含格式后缀的文件名)
			size: data.size // 需要预览文件的字节大小(必填，而且大小必须正确，否则会打开失败)
		});
	} else if (userAgent.indexOf('miniProgram') > 0 || window.__wxjs_environment === 'miniprogram') {
		// 微信小程序
		wx.miniProgram.navigateTo({
			url: '../previewFile/previewFile?path=' + encodeURIComponent(data.url)
		});
	} else {
		var protocolStr = document.location.protocol;
		console.log('非企业微信客户端打开~', protocolStr);
		//window.open(data.url)
		window.location.href = data.url;
	}
};

//下载文件
var dealBlob2 = exports.dealBlob2 = function dealBlob2(b, name) {
	if (window.navigator.msSaveBlob) {
		// 兼容ie11
		try {
			window.navigator.msSaveBlob(b, name);
		} catch (e) {
			console.log('windows download error...');
			console.log(e);
		}
	} else {
		var aLink = document.createElement('a');
		aLink.href = window.URL.createObjectURL(b);
		aLink.download = name;
		//此写法兼容可火狐浏览器
		document.body.appendChild(aLink);
		var evt = document.createEvent("MouseEvents");
		evt.initEvent("click", false, false);
		aLink.dispatchEvent(evt);
		document.body.removeChild(aLink);
	}
};

//飞书 获得用户code
var getUserCode = exports.getUserCode = function getUserCode() {
	return new Promise(function (resolve, reject) {
		window.h5sdk.ready(function () {
			if (window.tt.requestAccess) {
				window.tt.requestAccess({
					// 网页应用 App ID
					appID: window.feishu_appid,
					scopeList: [],
					success: function success(res) {
						// 用户授权后返回预授权码
						var code = res.code;

						resolve(code);
					},
					fail: function fail(error) {
						alert(JSON.stringify(error));
						// 需要额外根据errno判断是否为 客户端不支持requestAccess导致的失败
						var errno = error.errno,
						    errString = error.errString;

						if (errno === 103) {
							// 客户端版本过低，不支持requestAccess，需要改为调用requestAuthCode
							callRequestAuthCode();
						} else {
							// 用户拒绝授权或者授权失败
						}
					}
				});
			} else {
				// JSSDK版本过低，不支持requestAccess，需要改为调用requestAuthCode
				callRequestAuthCode();
			}

			function callRequestAuthCode() {
				window.tt.requestAuthCode({
					// 网页应用 App ID
					appId: window.feishu_appid,
					success: function success(res) {
						// 用户免登录后返回预授权码
						var code = res.code;

						resolve(code);
					},
					fail: function fail(error) {
						// 免登失败，返回相应的errno和errString
						var errno = error.errno,
						    errString = error.errString;
					}
				});
			}
		});
	});
};

/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _regenerator = __webpack_require__(75);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _toast = __webpack_require__(120);

var _toast2 = _interopRequireDefault(_toast);

__webpack_require__(121);

var _isomorphicFetch = __webpack_require__(197);

var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);

var _whitelist = __webpack_require__(126);

var _whitelist2 = _interopRequireDefault(_whitelist);

var _reactRouter = __webpack_require__(34);

var _tools = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

// 企业微信转发 -- 登陆页
var auth_url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=ww4643f3b8e6508f1d&redirect_uri=https%3a%2f%2fcwqw.grinm.com%2f&response_type=code&scope=snsapi_base#wechat_redirect';
//是否正在认证
var isAuthing = false;

var handleRequest = function handleRequest(url, method) {
	var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	var json = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

	var has = false;
	_whitelist2.default.forEach(function (val) {
		if (val == url) has = true;
	});

	var token = localStorage.getItem('token') || '';

	var header = Object.assign({}, {
		'Content-Type': json ? 'application/json' : 'application/x-www-form-urlencoded'
	}, has ? {} : {
		'Authorization': 'Bearer ' + token
	});

	if (method == 'UPLOAD') {
		method = 'POST';
		delete header['Content-Type'];
	}

	var req = {
		method: method,
		headers: new Headers(header)
	};
	if (method == 'POST') {
		req = Object.assign({
			body: json ? JSON.stringify(body) : body,
			bodyUsed: true
		}, req);
	}

	// let wholeUrl = `${process.env.API_URL}${url}	`
	var wholeUrl = url;

	if ("production" == 'production' && url.substr(0, 7) != '/weixin') {
		wholeUrl = '/xpro' + url;
	}

	return new Request(wholeUrl, req);
};

var handleResponse = function handleResponse(res) {
	return new Promise(function (rsl, rej) {
		rsl(res.json());
	}).then(function (res) {
		if (res.code === 700) {
			// 用户认证
			var params = (0, _tools.handleLocation)();
			if (params.code && !isAuthing) {
				isAuthing = true;
				fetchAuth({ code: params.code });
			} else if (window.platform === 'feishu' && !isAuthing) {
				isAuthing = true;
				(0, _tools.getUserCode)().then(function (code) {
					fetchAuth({ code: code, platform: 'feishu' });
				});
			} else if (!isAuthing) {
				//进行绑定 -- 登陆页
				window.location.href = auth_url;
			}
		} else if (res.code !== 200) {
			_toast2.default.fail(res.message);
		}
		return res;
	}).catch(function (err) {
		// Toast.offline('请求超时')
		console.error(new Error('status: ' + res.status + ', statusText: ' + res.statusText));
	});
};

var handleTimeout = function handleTimeout(url, type) {
	var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	var json = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	var times = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 10000;
	return Promise.race([new Promise(function (rsl, rej) {
		setTimeout(function (_) {
			rsl({ status: 500, statusText: 'Timeout' });
		}, times);
	}), (0, _isomorphicFetch2.default)(handleRequest(url, type, body, json))]);
};

var handleParams = function handleParams(params) {
	var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

	var str = '';
	for (var i in params) {
		str += i + '=' + params[i] + '&';
	}
	if (str.length) {
		str = '' + s + str.substring(0, str.length - 1);
	}
	return str;
};
//用户认证
var fetchAuth = function () {
	var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee(params) {
		var path;
		return _regenerator2.default.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						path = params.platform === 'feishu' ? 'feishu' : 'wechat';
						_context.next = 3;
						return handleTimeout('/auth/' + path + handleParams(params, '?'), 'GET').then(function (res) {
							return new Promise(function (rsl, rej) {
								rsl(res.json());
							});
						}).then(function (res) {
							if (res.code === 200) {
								isAuthing = false;
								localStorage.setItem('token', res.data.token);
								localStorage.setItem('username', res.data.userName);
								localStorage.setItem('userid', res.data.userId);
								localStorage.setItem('memberid', res.data.memberId);
							} else if (res.code === 508) {
								isAuthing = false;
								console.log('不合法的oauth_code');
							} else {
								var memberId = res.message;
								_reactRouter.hashHistory.push({ pathname: 'login', query: { memberId: memberId } });
							}
						});

					case 3:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, undefined);
	}));

	return function fetchAuth(_x7) {
		return _ref.apply(this, arguments);
	};
}();

exports.default = {
	auth_url: auth_url,
	fetchAuth: fetchAuth,
	fetchGet: function fetchGet(url) {
		var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
		var times = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100000;

		return handleTimeout('' + url + handleParams(params, '?'), 'GET', null, null, times).then(handleResponse);
	},
	fetchPost: function fetchPost(url) {
		var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
		var json = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
		var times = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 100000;

		return handleTimeout(url, 'POST', json ? params : handleParams(params), json, times).then(handleResponse);
	},
	upload: function upload(url) {
		var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

		return handleTimeout(url, 'UPLOAD', params, false, 900000).then(handleResponse);
	},
	fetchBlob: function fetchBlob(url) {
		var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

		return handleTimeout('' + url + handleParams(params, '?'), 'GET', null, null, 900000).then(function (response) {
			// console.log(response)
			if (response.status === 500 || response.code === 901) {
				_toast2.default.fail('没有找到对应的资料');
			} else {
				return response.blob();
			}
		});
	}
};

/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var RESET = exports.RESET = 'RESET';
var START_LOADING = exports.START_LOADING = 'START_LOADING';
var CLOSE_LOADING = exports.CLOSE_LOADING = 'CLOSE_LOADING';

var SET_ACTIVE = exports.SET_ACTIVE = 'SET_ACTIVE';
var UPDATE_CART = exports.UPDATE_CART = 'UPDATE_CART';

/***/ })

},[128]);


// WEBPACK FOOTER //
// static/js/app.b55f3d3f926078b5b1b5.js